module.exports = __webpack_public_path__ + "img/image_success.01eea021.png";